import { useEffect, useRef, useState } from "react";
import { useInView, animate } from "framer-motion";
import { useLang } from "./ctx";
import { Reveal } from "./Motion";

const KEYS = ["counter-annual-capacity", "counter-clients", "counter-experience", "counter-countries"];

const Counter = ({ value, suffix }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.3 });
  const [n, setN] = useState(0);
  useEffect(() => {
    if (!inView) return undefined;
    const c = animate(0, value, { duration: 2.2, ease: [0.16, 1, 0.3, 1], onUpdate: (v) => setN(Math.round(v)) });
    return () => c.stop();
  }, [inView, value]);
  return <span ref={ref}>{n}<span className="text-[#A8874F]">{suffix}</span></span>;
};

export const Stats = () => {
  const { t } = useLang();
  return (
    <section id="stats" className="border-y border-stone-200 bg-white" data-testid="stats-section">
      <div className="mx-auto grid max-w-[1440px] grid-cols-2 lg:grid-cols-4">
        {t.stats.items.map((s, i) => (
          <Reveal key={KEYS[i]} delay={i * 0.08} className={`border-stone-200 px-6 py-12 lg:px-12 lg:py-16 ${i % 2 === 0 ? "border-r" : ""} ${i < 2 ? "border-b lg:border-b-0" : ""} ${i === 1 ? "lg:border-r" : ""}`}>
            <div data-testid={KEYS[i]} className="font-display text-5xl font-light tracking-tight text-stone-950 sm:text-6xl lg:text-7xl">
              <Counter value={s.value} suffix={s.suffix} />
            </div>
            <div className="mt-4 font-mono text-[11px] uppercase tracking-[0.22em] text-stone-500">{s.label}</div>
          </Reveal>
        ))}
      </div>
    </section>
  );
};
